import * as React from "react";
const SvgFlag = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M33 51v-4m0 0V35a2 2 0 0 1 2-2h6.5l1 1H51l-3 6 3 6h-8.5l-1-1H35a2 2 0 0 0-2 2m9-13.5V39"
    />
  </svg>
);
export default SvgFlag;
